/* eslint-disable */
export default {
  today: 'Vandaag',
  yesterday: 'Gisteren',
  empty: 'Geen oproepgegevens',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
